module.exports = __webpack_public_path__ + "static/media/cliiick.87ee75a2.gif";